import React from 'react';

const ProcessingMessage = () => {
  return (
    <div className="processing-message-wrapper">
      <span className="loader">
        <div className="load-wrapper">
          <span className="load-text" />
        </div>
      </span>
      <div className="processing-message-text-wrapper">
        <div className="processing-message-header">
          Hey! Your recently purchased contacts are now being added to this
          list.
        </div>
        <div className="processing-message-description">
          {'You will receive an email notification once it\'s done.'}
        </div>
      </div>
    </div>
  );
};

export default ProcessingMessage;
